// src/components/HomeCarousel.jsx
import React, { useState, useEffect, useRef } from 'react';
import "../style/HomeCarousel.css";

// ✅ Your CDN base URL
const CDN_BASE = "https://cdn.greateastern.in/GETCO/AD1(HOMESCREEN)/";

// Desktop banners (exact filenames from S3)
const desktopImages = [
  "26344_WM-FL-Bespoke-Banner_1920x552_tjnmnl.webp",
  "27161_DA-Bespoke-AI-Banner_1920x_n22gqa.webp",
  "26246_TMF-Ref_Retail_1920x552_ty89f1.webp",
  "Picture1_1_shmvps.webp",
];

// Mobile banners
const mobileImages = [
  "AD_1_1_s4khmp.png",
  "AD_4_1_uatker.png",
  "AD_3_1_e8kxce.jpg",
  "AD_2_1_cyvrq0.png",
];

const HomeCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideInterval = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const imagesToUse = isMobile ? mobileImages : desktopImages;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % imagesToUse.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + imagesToUse.length) % imagesToUse.length);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);

    if (slideInterval.current) {
      clearInterval(slideInterval.current);
    }

    slideInterval.current = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => {
      clearInterval(slideInterval.current);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);

  return (
    <div className="carousel-wrapper">
      <div className="carousel-slides">
        {imagesToUse.map((fileName, idx) => {
          const imgUrl = `${CDN_BASE}${fileName}`;
          return (
            <div
              key={idx}
              className={`carousel-slide ${idx === currentSlide ? 'active' : ''}`}
            >
              {/* ✅ Replaced Cloudinary <AdvancedImage> with normal <img> */}
              <img src={imgUrl} alt="banner" />
            </div>
          );
        })}
      </div>

      <button className="carousel-arrow left" onClick={prevSlide}>‹</button>
      <button className="carousel-arrow right" onClick={nextSlide}>›</button>

      <div className="carousel-dots">
        {imagesToUse.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default HomeCarousel;
